export default __webpack_public_path__ + "static/media/mastercard-bgblack.f343a582.svg";